import axios from "axios";
import config from "../Config";
import { ErrorNotificationMsg } from "../utils/Notifications";

const axiosClient = axios.create();
axiosClient.defaults.baseURL = config.API_URL;

// axiosClient.defaults.timeout = 5000;
axiosClient.defaults.timeout = 500000;

const token = localStorage.getItem("auth_token");

if (token && token !== null && token !== undefined) {
  axiosClient.defaults.headers.Authorization = token ? `Bearer ${token}` : null;
}

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const data = error.response.data;

      if (status === 500) {
        ErrorNotificationMsg("Server Error");
      } else if (status === 401 || status === 400 || status === 404) {
        if (data[0]) {
          ErrorNotificationMsg(data[0]);
        } else if (data.detail) {
          ErrorNotificationMsg(data.detail);
        } else if (data.message) {
          ErrorNotificationMsg(data.message);
        } else if (data.errors && data.errors[0] && data.errors[0].detail) {
          ErrorNotificationMsg(data.errors[0].detail);
        }
      }
    }

    return Promise.reject(error);
  }
);

export function getRequest(URL, params = null) {
  return axiosClient.get(`/${URL}`, { params }).then((response) => response);
}

export function postRequest(URL, payload) {
  return axiosClient.post(`/${URL}`, payload).then((response) => response);
}

export function patchRequest(URL, payload) {
  return axiosClient.patch(`/${URL}`, payload).then((response) => response);
}

export function deleteRequest(URL, params = null) {
  return axiosClient
    .delete(`/${URL}`, { data: params })
    .then((response) => response);
}
